import "./HeaderBar.css";

function formatTime(iso) {
  if (!iso) return null;
  try {
    return new Date(iso).toLocaleTimeString([], {
      hour:         "2-digit",
      minute:       "2-digit",
      timeZoneName: "short",
    });
  } catch {
    return iso;
  }
}

function StatusDot({ status }) {
  return <span className={`hb-dot hb-dot--${status}`} aria-hidden="true" />;
}

export default function HeaderBar({ site, lastUpdated, status }) {
  const time = formatTime(lastUpdated);

  return (
    <header className="hb">
      <div className="hb-brand">
        {/* Radar sweep icon */}
        <svg
          className="hb-logo"
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <circle cx="12" cy="12" r="2" fill="currentColor" />
          <circle
            cx="12" cy="12" r="5.5"
            stroke="currentColor" strokeWidth="1.5"
            fill="none" opacity="0.65"
          />
          <circle
            cx="12" cy="12" r="9.5"
            stroke="currentColor" strokeWidth="1"
            fill="none" opacity="0.35"
          />
          {/* Sweep line */}
          <line
            x1="12" y1="12" x2="12" y2="2.5"
            stroke="currentColor" strokeWidth="1.5"
            strokeLinecap="round" opacity="0.8"
          />
        </svg>
        <span className="hb-title">StormAtlas</span>
      </div>

      <div className="hb-meta">
        {site && <span className="hb-site">{site}</span>}

        {time ? (
          <span className="hb-updated">
            <StatusDot status={status} />
            {time}
          </span>
        ) : (
          <span className="hb-updated hb-updated--muted">
            <StatusDot status={status} />
            {status === "loading" ? "Connecting…" : status === "error" ? "Disconnected" : "No data"}
          </span>
        )}
      </div>
    </header>
  );
}
